import HttpService from './http.service.js'

class PaymentService {
  async createSubscription(payload) {
    return HttpService.post('payment/create-subscription', payload)
  }

  async cancelSubscription(payload) {
    return HttpService.post('payment/cancel-subscription', payload)
  }

  async continueSubscription(payload) {
    return HttpService.post('payment/continue-subscription', payload)
  }

  async updateDateFacturare(payload) {
    return HttpService.post('payment/update_date_facturare', payload)
  }

  async subscriptions(voucher) {
    if (voucher) {
      return HttpService.get(`payment/subscriptions?voucher=${voucher}`)
    }
    return HttpService.get('payment/subscriptions')
  }

  async invoices(payload) {
    return HttpService.get('payment/get_facturi', payload)
  }

  async createVoucher(payload) {
    return HttpService.post('payment/create_voucher', payload)
  }

  async loadVoucher(code) {
    return HttpService.get(`payment/load_voucher?code=${code}`)
  }
}

export default new PaymentService()
